// short
import HomeOwner from "./components/short/HomeOwner.vue"
import PropertyType from "./components/short/PropertyType.vue"
import CurrentHomeInsurer from "./components/short/CurrentHomeInsurer.vue"
import YearBought from "./components/short/YearBought.vue"
import DateOfBirth from "./components/short/DateOfBirth.vue"
import FinalQuestions from "./components/short/FinalQuestions.vue"


const steps = {
    Short: [
        HomeOwner.name,
        PropertyType.name,
        CurrentHomeInsurer.name,
        YearBought.name,
        DateOfBirth.name,
        FinalQuestions.name
    ],

};

const stepValues = {

    // short
    HomeOwner: HomeOwner.name,
    PropertyType: PropertyType.name,
    CurrentHomeInsurer: CurrentHomeInsurer.name,
    YearBought: YearBought.name,
    DateOfBirth: DateOfBirth.name,
    FinalQuestions: FinalQuestions.name

};

export { steps, stepValues }
